// front-end/src/index.js
import '../css/preproc/main.scss';
import './components/web-components';
import {initCarousel, initStepsNumbers} from './components/carousel';
import {initAccordion, initAccordionNumbers} from './components/accordion';
import {initAllSortables, initBlockSystem} from './components/block-system';
import {initContentEditor} from './components/content-editor-src';
import {publishTextChange} from './components/content-editor-src/text-editor';
import {initAdminInterface} from './components/admin-interface';
import {config} from './config/app-config';
import {isAuthenticated} from './components/auth';
import {initDiagnosticDetails} from "./components/diagnostic-details";
import "./components/video-player/player";
import {initDoctorModalsWithPublishPatch} from "./components/doctor-modal/modal";
import './components/content-editor-src/youtube-editor.js';
import {hasContactForm, hasVacancyForm, hasCourseContactForm, initContactForm, initVacancyForm, initCourseContactForm} from "./components/contact-form";
import './components/doctors-loader/about-us-doctors-loader';
import './components/certificates-loader/certificates-loader';
// НОВОЕ: Импортируем модальную систему для сертификатов
import './components/certificate-modal/certificate-modal';

// News & Cases: manager (листинг) + loaders
import './components/news-manager';
import './components/news-loader/news-article-loader';
import './components/news-loader/home-news-loader';
import './components/news-loader/news-feed-loader';
import './components/case-manager';
import './components/cases-loader/home-cases-loader';

import './components/simple-accordion/simple-accordion';
import './components/google-maps/maps';
import {initGoogleMaps} from './components/google-maps/maps';
import {initExpertisesBlocks} from "./components/experise-page-loader/loader";
import './components/expertise-manager';

import './components/vacancy-manager';
import './components/vacancies-loader/vacancies-loader';

import './components/course-manager';
import './components/courses-loader/courses-loader';
import './components/cases-loader';
import './components/diagnostic-manager';
import {initPageManager} from './components/page-manager/page-manager';
import {initNavigation} from "./components/navigation";



const App = {
    debounce(func, wait = 100) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    },

    async initialize() {
        console.log('Initializing application...');

        try {
            // ВАЖНО: Проверяем что NewsManager загружен
            console.log('Checking NewsManager availability:', !!window.newsManager);

            initCarousel(config.carousel);
            console.log('Carousel initialized');

            initStepsNumbers();
            console.log('Diagnostic steps numbering initialized');

            try {
                initAccordion(config.accordion);
                console.log('Accordion initialized');

                initAccordionNumbers();
                console.log('Accordion numbering initialized');
            } catch (error) {
                console.error('Failed to initialize accordion:', error);
            }

            try {
                await initBlockSystem();
                console.log('Block system initialized');

                // After block system loads, process diagnostic blocks
                if (window.diagnosticManager) {
                    window.diagnosticManager.processExistingBlocks();
                }

                // After block system loads, process expertise blocks
                if (window.expertiseManager) {
                    window.expertiseManager.processExistingBlocks();
                }

                if (isAuthenticated()) {
                    try {
                        initPageManager();
                        initAllSortables();
                        console.log('Block sortable initialized');
                    } catch (sortableError) {
                        console.error('Failed to initialize block sortable:', sortableError);
                    }
                }
            } catch (error) {
                console.error('Failed to initialize block system:', error);
            }

            // НОВОЕ: Инициализация блоков экспертиз ПОСЛЕ блочной системы
            try {
                await initExpertisesBlocks();
                console.log('Expertises blocks initialized');
            } catch (error) {
                console.error('Failed to initialize expertises blocks:', error);
            }

            // Инициализация контента ПОСЛЕ экспертиз
            try {
                const editorAPI = initContentEditor();
                console.log('Content editor initialized');

                if (publishTextChange) {
                    const patchedPublishTextChange = initDoctorModalsWithPublishPatch(publishTextChange);
                    window.publishTextChange = patchedPublishTextChange;
                } else {
                    initDoctorModalsWithPublishPatch(function () {
                        console.error('Original publishTextChange not found');
                    });
                }
                console.log('Doctor modals initialized with patched publishTextChange');
            } catch (error) {
                console.error('Failed to initialize content editor or doctor modals:', error);
            }

            try {
                initDiagnosticDetails();
                initAdminInterface();

                initNavigation();

                // ОБНОВЛЕНО: Инициализируем все типы контактных форм
                if (hasContactForm()) {
                    initContactForm();
                    console.log('Contact form initialized');
                }
                if (hasVacancyForm()) {
                    initVacancyForm();
                    console.log('Vacancy form initialized');
                }
                if (hasCourseContactForm()) {
                    initCourseContactForm();
                    console.log('Course contact form initialized');
                }

                console.log('Admin interface initialized');
            } catch (error) {
                console.error('Failed to initialize admin interface:', error);
            }

            if (window.courseManager) {
                console.log('✅ CourseManager confirmed available globally');
            } else {
                console.log('❌ CourseManager not available globally after initialization');
            }

            // НОВОЕ: Проверяем что загрузчик курсов инициализирован
            if (window.location.pathname.match(/courses(\.html)?$/)) {
                console.log('✅ Courses loader should be active');
            }

            // НОВОЕ: Инициализация Google Maps
            try {
                // Проверяем есть ли на странице элементы для карт
                if (document.getElementById('map') || document.getElementById('map-lviv')) {
                    await initGoogleMaps();
                    console.log('Google Maps initialized');
                } else {
                    console.log('No map elements found, skipping Google Maps initialization');
                }
            } catch (error) {
                console.error('Failed to initialize Google Maps:', error);
            }

            console.log('Application initialized successfully');

            // ДОПОЛНИТЕЛЬНАЯ ПРОВЕРКА: Убеждаемся что NewsManager доступен после инициализации
            setTimeout(() => {
                if (window.newsManager) {
                    console.log('✅ NewsManager confirmed available globally');
                } else {
                    console.error('❌ NewsManager not available globally after initialization');
                }

                // НОВОЕ: Проверяем что загрузчики новостей инициализированы
                if (window.location.pathname.match(/news-feed(\.html)?$/)) {
                    console.log('✅ News feed loader should be active');
                } else if (document.body.getAttribute('data-page') === 'Home') {
                    console.log('✅ Home news loader should be active');
                    console.log('✅ Home cases loader should be active');
                }

                // НОВОЕ: Проверяем что модальная система сертификатов инициализирована
                if (window.location.pathname.match(/certificates(\.html)?$/)) {
                    console.log('✅ Certificates loader should be active');
                    console.log('✅ Certificate modal system should be active');
                }

                // НОВОЕ: Проверяем доступность модальной системы
                if (window.certificateModal) {
                    console.log('✅ Certificate modal system confirmed available globally');
                } else {
                    console.log('⚠️ Certificate modal system not available globally (normal if not on certificates page)');
                }

                // НОВОЕ: Проверяем что форма курса инициализирована
                if (window.location.pathname.match(/course-detail(\.html)?$/) || document.body.getAttribute('data-page') === 'Course-detail') {
                    console.log('✅ Course contact form should be active');
                }
            }, 500);

            document.dispatchEvent(new CustomEvent('carousel:initialized'));
        } catch (error) {
            console.error('Failed to initialize application:', error);
        }
    },

    handleResize: null
};

App.handleResize = App.debounce(() => {
    const resizeEvent = new CustomEvent('app:resize', {
        detail: {
            width: window.innerWidth,
            height: window.innerHeight
        }
    });
    document.dispatchEvent(resizeEvent);
}, 150);

document.addEventListener('DOMContentLoaded', App.initialize);
window.addEventListener('resize', App.handleResize);

export default App;